/* @flow */
import { SuccessIcon } from '@/assets/icons'
import React from 'react'
class Success extends React.PureComponent {
  handleClick() {
    const { onMessageClick } = this.props
    if (onMessageClick) {
      onMessageClick(import.meta.env.VITE_FRONT_URL)
    }
  }

  render() {
    const { title, body } = this.props
    return (
      <div className="flex items-center gap-4" onClick={this.handleClick.bind(this)}>
        <SuccessIcon />

        <div className="message__text">
          <div className="message__main-text">{title}</div>
          <div className="message__sub-text">{body}</div>
        </div>
      </div>
    )
  }
}

export default Success
